<textarea [ngModel]="data" (ngModelChange)="onChange($event)" [disabled]="disabled"></textarea>
